<template>
  <el-popover
    placement="bottom-start"
    trigger="hover"
    width="500"
    append-to-body
    :popper-class="$style.popper"
    :disabled="commentCount === 0"
  >
    <div :class="$style.body">
      <div v-if="comments.length > 0" :class="$style.comments">
        <comment-display
          v-for="comment in comments"
          :key="comment.id"
          :comment="comment"
          inactive
        />
      </div>
      <div :class="$style.hint">
        <el-link @click="showDrawer">
          <template v-if="commentCount > comments.length">
            zu den Kommentaren
            <template v-if="commentCount - comments.length === 1">
              (+ ein älterer Kommentar)
            </template>
            <template v-else>
              (+ {{ commentCount - comments.length }} ältere Kommentare)
            </template>
          </template>
          <template v-else> zu den Kommentaren </template>
        </el-link>
      </div>
    </div>
    <template #reference
      ><comment-count :count="commentCount" :size="size" @click="showDrawer"
    /></template>
  </el-popover>
</template>

<script>
import { $emit } from "../../util/gogocodeTransfer";
import CommentDisplay from "~/src/components/comments/CommentDisplay";
import CommentCount from "~/src/components/comments/CommentCount";

export default {
  name: "CommentPopover",
  components: { CommentCount, CommentDisplay },
  inject: ["openCommentDrawer"],
  props: {
    commentable: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: "default",
    },
  },
  emits: ["update", "count", "comments"],
  data() {
    return {
      updatedCommentCount: null,
      updatedComments: null,
    };
  },
  computed: {
    commentCount() {
      const { commentable, updatedCommentCount } = this;
      if (updatedCommentCount !== null) {
        return updatedCommentCount;
      }
      return (
        (commentable && commentable.commentsCount) ||
        (commentable &&
          commentable.comments &&
          commentable.comments.totalCount) ||
        0
      );
    },
    comments() {
      const { commentable, updatedComments } = this;

      if (updatedComments !== null) {
        return updatedComments;
      }
      return (
        (commentable && commentable.comments && commentable.comments.nodes) ||
        []
      );
    },
  },
  watch: {
    commentable() {
      this.updatedCommentCount = null;
      this.updatedComments = null;
    },
  },
  methods: {
    showDrawer() {
      return this.openCommentDrawer(this.commentable).then((data) => {
        if (data) {
          $emit(this, "update", data.comment);
          const c = {
            totalCount: data.comments.totalCount,
            nodes:
              data.comments.nodes.length > 0
                ? [data.comments.nodes.reverse()[0]]
                : [],
          };
          this.updatedCommentCount = c.totalCount;
          this.updatedComments = c.nodes;
          $emit(this, "comments", c);
          $emit(this, "count", c.totalCount);
        }
      });
    },
  },
};
</script>

<style lang="module.css" module>
.popper.popper {
  padding: 0;
}
.body {
  position: relative;
  word-break: normal;
  text-align: left;
}
.comments {
  max-height: 260px;
  overflow: hidden;
  padding: 12px 12px 40px;
}
.hint {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--el-bg-color-overlay);
  mask: linear-gradient(to bottom, rgb(0 0 0 / 0), rgb(0 0 0 / 1) 50%);
  text-align: center;
  padding-block: 6px;
}
</style>
